export default __webpack_public_path__ + "static/usb_c_xr_charging_adapter-1fa4343218cb8a7485d4896317873292.png";